// extracted by mini-css-extract-plugin
export default {"heroSection":"heroSection_heroSection__mtdgJ","heroSectionLeft":"heroSection_heroSectionLeft__l-iYT","customBtn":"heroSection_customBtn__e68Ve"};